const o = {
  id: "ArkansasLotto",
  name: "Lotto",
  style: {
    colorPrimary: "#e42440",
    extraBall: {
      bg: "#e42440",
      color: "#ffffff",
      fontSize: "0.875rem"
    }
  }
};
export {
  o as default
};
